/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMicrophone2 = createReactComponent("outline", "microphone-2", "IconMicrophone2", [["path", { "d": "M15 12.9a5 5 0 1 0 -3.902 -3.9", "key": "svg-0" }], ["path", { "d": "M15 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z", "key": "svg-1" }]]);

export { IconMicrophone2 as default };
//# sourceMappingURL=IconMicrophone2.mjs.map
